import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import ProductCard from "../components/ProductCard";
import { Guitar, ArrowRight } from "lucide-react";

export default function Instruments() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get("/products", { params: { category: "Instruments" } })
      .then((r) => setProducts(r.data || []))
      .finally(() => setLoading(false));
  }, []);

  const spans = ["lg", "sm", "sm", "lg", "md", "md", "xl"];

  return (
    <div data-testid="instruments-page" className="bg-stone-950 text-stone-50 pt-14 pb-24">
      <div className="max-w-[1400px] mx-auto px-6 sm:px-12 lg:px-16">
        <div className="border-b border-stone-800/60 pb-12 mb-12">
          <p className="text-overline text-amber-600 mb-4">Instruments</p>
          <h1 className="font-display text-5xl sm:text-6xl lg:text-7xl font-black tracking-tighter uppercase leading-[0.95]">
            Wood that
            <br />
            <span className="text-amber-600">sings.</span>
          </h1>
          <p className="text-stone-400 mt-6 max-w-2xl text-lg leading-relaxed">
            Hand-built instruments — each one tuned, finished, and signed by
            the same set of hands that shaped the wood.
          </p>
        </div>

        {loading ? (
          <p className="text-stone-500" data-testid="instruments-loading">
            Loading…
          </p>
        ) : products.length === 0 ? (
          <div
            data-testid="instruments-empty"
            className="border border-stone-800 bg-stone-900/40 p-12 sm:p-20 text-center"
          >
            <Guitar size={48} className="text-amber-600 mx-auto mb-6" strokeWidth={1.5} />
            <h2 className="font-display text-3xl sm:text-4xl font-bold">
              Coming soon.
            </h2>
            <p className="text-stone-400 mt-4 max-w-md mx-auto leading-relaxed">
              The first instruments are on the bench. Sign up for a custom
              build below to commission one yourself.
            </p>
            <Link
              to="/custom"
              data-testid="instruments-custom-cta"
              className="inline-flex items-center gap-3 mt-8 bg-amber-700 hover:bg-amber-600 text-stone-50 px-8 py-4 text-overline transition-colors"
            >
              Commission an instrument <ArrowRight size={16} />
            </Link>
          </div>
        ) : (
          <div
            data-testid="instruments-grid"
            className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6"
          >
            {products.map((p) => (
              <ProductCard key={p.id} product={p} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
